import React from "react";

export const EmbedContainer = React.forwardRef(
    ({ children }, ref) => <div ref={ref} className="scp-flex scp-flex-col scp-gap-4 scp-embed-container scp-text-base">{children}</div>
);

